import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SponsorContextType {
  isSponsorEnabled: boolean;
  toggleSponsor: () => void;
  setSponsorEnabled: (enabled: boolean) => void;
}

const SponsorContext = createContext<SponsorContextType | undefined>(undefined);

interface SponsorProviderProps {
  children: ReactNode;
}

export const SponsorProvider: React.FC<SponsorProviderProps> = ({ children }) => {
  const [isSponsorEnabled, setIsSponsorEnabled] = useState<boolean>(false);

  const toggleSponsor = () => {
    setIsSponsorEnabled(prev => !prev);
  };

  const setSponsorEnabled = (enabled: boolean) => {
    setIsSponsorEnabled(enabled);
  };

  return (
    <SponsorContext.Provider value={{
      isSponsorEnabled,
      toggleSponsor,
      setSponsorEnabled
    }}>
      {children}
    </SponsorContext.Provider>
  );
};

export const useSponsor = (): SponsorContextType => {
  const context = useContext(SponsorContext);
  if (context === undefined) {
    throw new Error('useSponsor must be used within a SponsorProvider');
  }
  return context;
};
